// import axios from "axios";
import api from "../config/api";
import { EmployeeAttachment } from "../types/EmployeeAttachment";
// import {  } from "../types/Employee";

const API_URL = "/employeeAttachment";

// Get all employeesAttachement
export const getEmployeeAttachments = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });

// Get employeeAttachment by ID using query parameter
export const getEmployeeById = (employeeId: string) =>
  api.get(`${API_URL}/?id=${employeeId}`);

// Create a new employeeAttachment (typically uses POST)
export const createEmployeeAttachment = (formdata: FormData) =>
  api.post(`${API_URL}/`, formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// Update an employeeAttachment using query parameter
export const updateEmployeeAttachment = (
  id: number,
  data: EmployeeAttachment,
) => api.put(`${API_URL}/?id=${id}`, data);

// Delete an employeeAttachment using query parameter
export const deleteEmployeeAttachment = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
